// extracted by mini-css-extract-plugin
module.exports = {"simple_division":"simpledivision_simple_division__1PEud","simple_division__action":"simpledivision_simple_division__action__2d3u7"};